import React from 'react';
import Layout from './Layout';
import { useFlow } from '../hooks/useFlow';

interface FacilityConfirmationProps {
  facilityId: string | null;
  clinicName: string | null;
  onConfirm: () => void;
}

const FacilityConfirmation: React.FC<FacilityConfirmationProps> = ({ facilityId, clinicName, onConfirm }) => {
  const { setFlow } = useFlow();

  return (
    <Layout flowName="">
      <div className="text-center">
        <p className="text-2xl sm:text-3xl font-bold text-gray-700 my-8">入力内容確認</p>
        <p className="text-sm sm:text-base text-gray-500 mb-8">以下の内容でお間違いなければ次へお進みください。</p>
      </div>
      <div className="bg-gray-100 border border-gray-300 rounded-md p-4 mb-8 w-full sm:w-1/2 mx-auto">
        <p className="text-sm font-medium text-gray-700 mb-2">施設ID</p>
        <p className="text-lg text-gray-900 mb-4">{facilityId}</p>
        <p className="text-sm font-medium text-gray-700 mb-2">施設名</p>
        <p className="text-lg text-gray-900">{clinicName}</p>
      </div>
      <div className="w-full sm:w-1/2 mx-auto flex flex-col gap-4">
        <button
          onClick={onConfirm}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded w-full"
        >
          次へ進む
        </button>
        <button
          onClick={() => setFlow('facilityInput')}
          className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-3 px-6 rounded border border-gray-400 w-full"
        >
          入力画面に戻る
        </button>
      </div>
    </Layout>
  );
};

export default FacilityConfirmation;
